"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDeleteAccount = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactQuery = require("react-query");

var _api = require("../api");

var _types = require("../types");

var _utility = require("../utility");

var _context = require("../context");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var useDeleteAccount = function useDeleteAccount() {
  var context = _react["default"].useContext(_context.AuthContext);

  if (!context) {
    throw new Error('useDeleteAccount must be used within an AuthProvider');
  }

  var dispatch = context.dispatch;
  var queryClient = (0, _reactQuery.useQueryClient)();
  return (0, _reactQuery.useMutation)(function () {
    return (0, _api.deleteAccount)();
  }, {
    onSuccess: function onSuccess() {
      dispatch({
        type: _context.AuthActions.LOGOUT
      });
      (0, _utility.removeToken)();
      queryClient.invalidateQueries(_types.QueryKeys.Account);
    }
  });
};

exports.useDeleteAccount = useDeleteAccount;